/**
 * 购物车与购物车 v2
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/cart',
    name: 'cart',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/cart/index.vue'
      ),
    meta: {
      title: '购物车'
    }
  },
  {
    path: '/cart/success',
    name: 'cartSuccess',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/cart/success.vue'
      ),
    meta: {
      title: '结果页'
    }
  },
  {
    // 购物车（升级版）：业务逻辑对齐 mall_h5 的 /cart（专场 tab + 仓库维度 + 库存/结算）
    // 独立于原有 /cart 路由，原有页面与组件不做任何改动
    path: '/cart_v2',
    name: 'cartV2',
    component: () =>
      import(
        /* webpackChunkName: "cartV2" */
        '@/views/cartV2/index.vue'
      ),
    meta: {
      title: '购物车',
      // 页面里有 activated（回到购物车时刷新地址与列表），缓存是设计意图。
      // 原先写在记录级不生效（App.vue 判定的是 $route.meta.keepAlive），这里移进 meta
      keepAlive: true
    }
  }
];
